"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _transition = _interopRequireDefault(require("../helpers/transition"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 0;\n  flex: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ListItemStyled = (0, _styledComponents.default)(function (_ref) {
  var active = _ref.active,
      props = _objectWithoutProperties(_ref, ["active"]);

  return _react.default.createElement(_ListItem.default, props);
})(_templateObject(), function (props) {
  return props.button && "\n      color: ".concat(props.theme.palette.common.black, ";\n      border: 2px solid transparent;\n      padding: 10px 16px;\n      margin-bottom: 8px;\n      transition: ").concat((0, _transition.default)(props.theme.transitions).join(','), ";\n      &:hover, &:focus {\n        border: 2px solid ").concat(props.theme.palette.primary.main, ";\n        border-radius: 2px;\n      }\n\n      &:hover {\n        background-color: ").concat(props.theme.palette.getLighterColor(props.theme.palette.primary.main), ";\n      }\n      \n      &:focus, &:active {\n        background-color: ").concat(props.theme.palette.getLighterColor(props.theme.palette.primary.light), ";\n      }\n\n      ").concat(props.active && "\n          border: 2px solid ".concat(props.theme.palette.primary.main, ";\n          border-radius: 2px;\n          background-color: ").concat(props.theme.palette.getLighterColor(props.theme.palette.primary.light), ";\n      "), "\n    ");
});

var Label = _styledComponents.default.span(_templateObject2(), function (props) {
  return "\n    margin-left: 15px;\n    padding: 4px 8px;\n    font-family: ".concat(props.theme.typography.fontFamily, ";\n    font-size: ").concat(props.theme.typography.fontSize, "px;\n    color: ").concat(props.theme.palette.getContrastText(props.theme.palette.primary.main), ";\n    font-weight: ").concat(props.theme.typography.fontWeightSemiBold, ";\n    background-color: ").concat(props.theme.palette.primary.main, ";\n    border-radius: 2px;\n    text-decoration: none;\n  ");
});

var StyledListItemText = (0, _styledComponents.default)(_ListItemText.default).attrs({
  primaryTypographyProps: {
    variant: 'body2'
  }
})(_templateObject3());

var ListItemClassic = function ListItemClassic(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return _react.default.createElement(ListItemStyled, props, children);
};

ListItemClassic.Text = StyledListItemText;
ListItemClassic.Label = Label;
ListItemClassic.Icon = _ListItemIcon.default;
ListItemClassic.defaultProps = {
  active: false
};
/** @component */

var _default = ListItemClassic;
exports.default = _default;